import { useDispatch } from 'react-redux';
import { CustomTextArea } from '../../../../common/CustomTextArea';
import CustomTextField from '../../../../common/CustomTextField';
import {
  renderCheckboxes,
  renderDropdownWithoutLabel,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { setEmbryologyData } from '../../../../actions/embryologyActions';
import { TextField } from '@mui/material';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';

const EmbryologyDetailsWithEmbryologist = ({
  embryoTransferDetails,
  handleDateChange,
  handleTimeChange,
  handleInputChange,
  isFrozen = false,
}) => {
  const dispatch = useDispatch();

  const handleCatherChange = (e, index, name) => {
    console.log(e.target.name, e.target.checked);
    const { checked } = e.target;

    if (name === 'BloodOfTheCatherCheckbox') {
      const updatedCheckboxes =
        embryoTransferDetails.BloodOfTheCatherCheckbox.map((item, idx) =>
          idx === index ? { ...item, checked } : item,
        );
      if (isFrozen) {
        dispatch(
          setEmbryologyData(
            `embryoFrozenTransferDetails.BloodOfTheCatherCheckbox`,
            updatedCheckboxes,
          ),
        );
      } else {
        dispatch(
          setEmbryologyData(
            `embryoTransferDetails.BloodOfTheCatherCheckbox`,
            updatedCheckboxes,
          ),
        );
      }
    }

    if (name === 'mucusOnTheCatherCheckbox') {
      const updatedCheckboxes =
        embryoTransferDetails.mucusOnTheCatherCheckbox.map((item, idx) =>
          idx === index ? { ...item, checked } : item,
        );
      if (isFrozen) {
        dispatch(
          setEmbryologyData(
            `embryoFrozenTransferDetails.mucusOnTheCatherCheckbox`,
            updatedCheckboxes,
          ),
        );
      } else {
        dispatch(
          setEmbryologyData(
            `embryoTransferDetails.mucusOnTheCatherCheckbox`,
            updatedCheckboxes,
          ),
        );
      }
    }
  };

  return (
    <div className="card">
      <div className="body" style={{ display: 'flex', gap: '10px' }}>
        <table
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <tbody>
            {isFrozen && (
              <>
                <tr>
                  <td>Date</td>
                  <td>
                    <DateComponent
                      id="date"
                      selectedDate={
                        embryoTransferDetails.date
                          ? dayjs(embryoTransferDetails.date)
                          : null
                      }
                      handleDateChange={(date, dateString) =>
                        handleDateChange(date, 'date')
                      }
                    />
                  </td>
                  <td>Time </td>
                  <td>
                    <TextField
                      type="time"
                      variant="standard"
                      value={embryoTransferDetails.time}
                      onChange={(e) => handleTimeChange(e.target.value, 'time')}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Media </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'media',
                      embryoTransferDetails.media,
                      handleInputChange,
                    )}
                  </td>

                  <td>Transfer </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      'transfer',
                      embryoTransferDetails.transfer,

                      [' ', 'Self', 'Surrogate'],
                      handleInputChange,
                    )}
                  </td>
                </tr>

                <tr>
                  <td>Surrogate Name</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'surrogateName',
                      embryoTransferDetails.surrogateName,
                      handleInputChange,
                      false,
                      null,
                      embryoTransferDetails.transfer !== 'Surrogate',
                    )}
                  </td>
                  <td>Surrogate Age</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      disabled={embryoTransferDetails.transfer !== 'Surrogate'}
                      value={embryoTransferDetails.surrogateAge}
                      name={'surrogateAge'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                </tr>
                <tr>
                  <td>Surrogate MPI</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'surrogateMPI',
                      embryoTransferDetails.surrogateMPI,
                      handleInputChange,
                      false,
                      null,
                      embryoTransferDetails.transfer !== 'Surrogate',
                    )}
                  </td>
                  <td>Surrogate Aadhar No</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      disabled={embryoTransferDetails.transfer !== 'Surrogate'}
                      value={embryoTransferDetails.surrogateAadharNumber}
                      name={'surrogateAadharNumber'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                </tr>
                <tr>
                  <td>No. Of Embryos Transferred</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={embryoTransferDetails.noOfEmbryoTransfered}
                      name={'noOfEmbryoTransfered'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                  <td>Grade Of Embryos Transferred</td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      'gradeOfEmbryo',
                      embryoTransferDetails.gradeOfEmbryo,
                      handleInputChange,
                    )}
                  </td>
                </tr>
                <tr>
                  <td>No. Of Embryos Refrozen</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={embryoTransferDetails.noOfEmbryoRefrozen}
                      name={'noOfEmbryoRefrozen'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                  <td>No. Of Embryos Discarded</td>
                  <td>
                    <CustomTextField
                      type="number"
                      onWheel={(e) => e.target.blur()}
                      value={embryoTransferDetails.noOfEmbryoDiscarded}
                      name={'noOfEmbryoDiscarded'}
                      onChange={handleInputChange}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </td>
                </tr>
              </>
            )}
            <tr>
              <td>Transfer Details </td>
              <td>
                {renderDropdownWithoutLabel(
                  'transferDetails',
                  embryoTransferDetails.transferDetails,

                  [' ', 'Easy', 'Difficult'],
                  handleInputChange,
                )}
              </td>
              <td>Endometrial Thickness(in mm): </td>
              <td>
                <CustomTextField
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={embryoTransferDetails.EndometrialThickness}
                  name={'EndometrialThickness'}
                  onChange={handleInputChange}
                  variant="outlined"
                  size="small"
                  fullWidth
                />
              </td>
            </tr>
            {isFrozen && (
              <tr>
                <td>Embryo Retention After ET:</td>

                <td>
                  {renderDropdownWithoutLabel(
                    'embryoRetentionAfterET',
                    embryoTransferDetails.embryoRetentionAfterET,
                    [' ', 'Yes', 'No'],
                    handleInputChange,
                  )}
                </td>
              </tr>
            )}
            <tr>
              <td>Blood on the Catheter</td>
              <td>
                {renderDropdownWithoutLabel(
                  'BloodOfTheCatheter',
                  embryoTransferDetails.BloodOfTheCatheter,
                  [' ', 'Yes', 'No'],
                  handleInputChange,
                )}
                {embryoTransferDetails.BloodOfTheCatheter === 'Yes' && (
                  <>
                    {renderCheckboxes(
                      embryoTransferDetails.BloodOfTheCatherCheckbox,
                      (e, index) =>
                        handleCatherChange(
                          e,
                          index,
                          'BloodOfTheCatherCheckbox',
                        ),
                      null,
                      'BloodOfTheCatherCheckbox',
                      null,
                      false,
                      embryoTransferDetails.BloodOfTheCatheter === 'No',
                    )}
                  </>
                )}
              </td>
              <td>Mucus on the Catheter </td>
              <td>
                {renderDropdownWithoutLabel(
                  'mucusOnTheCatheter',
                  embryoTransferDetails.mucusOnTheCatheter,
                  [' ', 'Yes', 'No'],
                  handleInputChange,
                )}
                {embryoTransferDetails.mucusOnTheCatheter === 'Yes' && (
                  <>
                    {renderCheckboxes(
                      embryoTransferDetails.mucusOnTheCatherCheckbox,
                      (e, index) =>
                        handleCatherChange(
                          e,
                          index,
                          'mucusOnTheCatherCheckbox',
                        ),
                      null,
                      'mucusOnTheCatherCheckbox',
                      null,
                      false,
                      embryoTransferDetails.BloodOfTheCatheter === 'No',
                    )}
                  </>
                )}
              </td>
            </tr>
            <tr>
              <td>Embryologist </td>
              <td>
                {renderInputFieldWithoutLabel(
                  'embryologist',
                  embryoTransferDetails.embryologist,
                  handleInputChange,
                )}
              </td>
              <td>Clinician</td>
              <td>
                {renderInputFieldWithoutLabel(
                  'clinician',
                  embryoTransferDetails.clinician,
                  handleInputChange,
                )}
              </td>
            </tr>
            <tr>
              <td>Dish Witness</td>
              <td>
                {renderInputFieldWithoutLabel(
                  'dishWitness',
                  embryoTransferDetails.dishWitness,
                  handleInputChange,
                )}
              </td>
              <td>Patient ID Witness</td>
              <td>
                {renderInputFieldWithoutLabel(
                  'patientIdWitness',
                  embryoTransferDetails.patientIdWitness,
                  handleInputChange,
                )}
              </td>
            </tr>
            <tr>
              <td>Remarks</td>
              <td colSpan={3}>
                <CustomTextArea
                  minRows={2}
                  maxRows={3}
                  value={embryoTransferDetails.remarks}
                  onChange={handleInputChange}
                  name="remarks"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default EmbryologyDetailsWithEmbryologist;
